import { render } from "./TradeIndicator.vue?vue&type=template&id=12825dc2&scoped=true"
import script from "./TradeIndicator.vue?vue&type=script&lang=js"
export * from "./TradeIndicator.vue?vue&type=script&lang=js"

import "./TradeIndicator.vue?vue&type=style&index=0&id=12825dc2&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12825dc2"]])

export default __exports__